import clsx from "clsx";
import { PropsWithChildren, ReactNode, memo, useMemo } from "react";

interface Props extends PropsWithChildren {
  as?: "label" | "span";
  label?: ReactNode;
  description?: ReactNode;
  descriptionClassName?: string;
  className?: string;
}

export const Field = memo(function Field(props: Props) {
  const { as = "span", label, description, children, className } = props;

  const isCompact = className?.includes("compact-field");

  const labelElement = useMemo(
    () => (
      <span
        className={clsx(
          "font-medium text-858494",
          isCompact ? "text-14 md:text-16" : "text-16"
        )}
      >
        {props.label}
      </span>
    ),
    [props.label, isCompact]
  );

  return (
    <div className={clsx("grid", isCompact ? "gap-2" : "gap-3", className)}>
      {label && (
        <>
          {as === "label" && (
            <label className={clsx("grid", isCompact ? "gap-2" : "gap-3")}>
              {labelElement}
              {children}
            </label>
          )}

          {as !== "label" && (
            <div className={clsx("grid", isCompact ? "gap-2" : "gap-3")}>
              {labelElement}
              {children}
            </div>
          )}
        </>
      )}

      {!label && children}

      {description && (
        <span
          className={clsx(
            isCompact
              ? "text-12 md:text-14 text-858494"
              : "text-14 text-858494",
            props.descriptionClassName
          )}
        >
          {description}
        </span>
      )}
    </div>
  );
});
